// extracted by mini-css-extract-plugin
export default {"content":"App_content__M+ncV","message":"App_message__4I10v"};